/**
 * analytics.js — тънък wrapper около window.gtag за GA4 custom events.
 *
 * Защо не директно gtag? Предимства:
 *  - Безопасност: не чупи app-а, ако analytics е блокиран (adblocker) или
 *    gtag все още не е зареден.
 *  - Централно място за добавяне/debug на нови събития.
 *  - Лесно мокване при тестове (spy на import).
 *
 * Используване:
 *   import { track } from "@/utils/analytics";
 *   track("meal_logged", { dil: 25.5, meal_type: "breakfast" });
 */

export function track(eventName, params = {}) {
  try {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    window.gtag("event", eventName, params);
  } catch (err) {
    // Analytics must never break UX. Log only in dev to help diagnose config issues.
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      if (process.env.NODE_ENV === 'development') console.warn("[analytics] track failed:", eventName, err);
    }
  }
}

// Semantic helpers за най-важните conversion моменти (autocomplete-friendly).
export const trackSignUp = (method = "email") => track("sign_up", { method });

export const trackTrialStarted = (plan_id, trial_length_days) =>
  track("trial_started", { plan_id, trial_length_days });

export const trackPlanPurchased = (plan_id, value, currency = "EUR", billing_period = "monthly") =>
  track("plan_purchased", { plan_id, value, currency, billing_period });

export const trackMealLogged = (dil, meal_type, source = "local") =>
  track("meal_logged", { value: Math.round(dil * 10) / 10, meal_type, source });

export const trackMealPlanGenerated = (days = 7, phenotype = "") =>
  track("meal_plan_generated", { days, phenotype });
